import { useCallback, useEffect, useState } from 'react';

export const useStateWithSyncExternalData = (value) => {
  const [state, setState] = useState(value);

  const setValue = useCallback((value) => {
    let nextValue = value;

    // если value - это объект с полями name и value
    if (
      typeof value === 'object' &&
      !Array.isArray(value) &&
      value.hasOwnProperty('name') &&
      value.hasOwnProperty('value')
    ) {
      const { name, value: v } = value;
      nextValue = (prev) => ({ ...prev, [name]: v });
    }

    setState(nextValue);
  }, []);

  useEffect(() => {
    setState((prev) => (prev !== value ? value : prev));
  }, [value]);

  return { state, setState: setValue };
};
